import { ArrowUp, ArrowDown, ChefHat } from "lucide-react";
import { resolveImg } from "@/lib/api";

export const sortByOrder = (items, order) => {
  const idx = Object.fromEntries(order.map((id, i) => [id, i]));
  return [...items].sort((a, b) => (idx[a.id] ?? order.length) - (idx[b.id] ?? order.length));
};

export default function MenuOrderList({ items, onChange }) {
  const move = (i, d) => {
    const ids = items.map((p) => p.id);
    [ids[i], ids[i + d]] = [ids[i + d], ids[i]];
    onChange(ids);
  };
  return (
    <div className="card-cocarde p-6" data-testid="menu-order-section">
      <h3 className="font-display text-xl cc-navy">Ordre de ma carte</h3>
      <p className="text-slate-500 text-sm mb-4">C'est l'ordre dans lequel vos clients voient vos pizzas sur votre page et lors de la commande.</p>
      <ol className="space-y-2">
        {items.map((p, i) => (
          <li key={p.id} data-testid={`menu-order-item-${i}`} className="flex items-center gap-3 border border-slate-200 rounded-xl px-3 py-2">
            <span className="font-display text-lg text-cc-red w-6">{i + 1}</span>
            {p.image_url ? <img src={resolveImg(p.image_url)} alt="" className="w-9 h-9 rounded-lg object-cover bg-slate-100" /> : <span className="w-9 h-9 rounded-lg bg-slate-100" />}
            <span className="flex-1 font-bold cc-navy truncate">{p.name || "Pizza sans nom"}</span>
            {p.custom && <span className="text-xs font-bold text-green-700 bg-green-100 rounded-full px-2 py-0.5 hidden sm:inline-flex items-center gap-1"><ChefHat size={11} /> Maison</span>}
            <button type="button" data-testid={`menu-order-up-${i}`} disabled={i === 0} onClick={() => move(i, -1)} className="p-1.5 rounded-lg hover:bg-slate-100 disabled:opacity-30"><ArrowUp size={16} /></button>
            <button type="button" data-testid={`menu-order-down-${i}`} disabled={i === items.length - 1} onClick={() => move(i, 1)} className="p-1.5 rounded-lg hover:bg-slate-100 disabled:opacity-30"><ArrowDown size={16} /></button>
          </li>
        ))}
      </ol>
    </div>
  );
}
